import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AbstractService } from '../commons/abstract.service';
import { Funnel } from "../models/funnel.model";

@Injectable({ providedIn: 'root' })
export class FunnelService extends AbstractService<Funnel> {
  constructor(private http: HttpClient) {
    super(http);
  }

  getURLBase(): string {
    return '/funnel';
  }

  preCreate(obj: Funnel): void {
    delete obj._id;
  }

  preUpdate(obj: Funnel): void {
  }
}
